import api from './api'

export const getClientes = async (nuvemOnly = false) => {
    if (nuvemOnly) {
        return await api.get('/api/clientes', { params: { nuvemOnly: true } });
    }
    return await api.get('/api/clientes');
}